import React from "react";
import {
  Create,
  TextInput,
  SimpleForm,
  useNotify,
  useRefresh,
  useRedirect,
  SelectInput,
  required,
  ReferenceInput,
  NumberInput,
  AutocompleteInput,
} from "react-admin";

import { useCreateStyles } from "../__common/MyStyles";
import { MyCreateActions } from "../__common/MyCreateActions";
import { sleep } from "../../common/js/Functions";

import { GenericTable } from "../__common/GenericTable"
import { PhagesHostsFields } from "./PhagesHostsFields";
import { PhagesHostsExternalFields } from "./PhagesHostsExternalFields";

/*export const DynamicInput = (props) => {

  console.log("props", props);

  const form = useForm();
  const [reload, setReload] = useState(0);

  let formdata = form.getState().values;
  const code = formdata[props.code] ?? undefined;
  console.log("Hola");
  console.log(formdata);
  console.log("Chau");

  console.log(code);
  console.log("fin");

  form.change("code", props.auxCode);


  return (
    <TextInput source="code" />
  );
}*/

export const PhagesCreate = (props) => {
  const classes = useCreateStyles();

  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = () => {
    notify(`Phage created`);
    sleep(2000).then(() => {
      redirect("/phages");
      refresh();
    });
  };

  /*  let auxCode = "20";
    let auxPhage = "";
    let auxGeneration = "";
  
  
    const updateAuxCode = (auxPhage, auxGeneration) => {
      auxCode = `${auxPhage}.${auxGeneration}`;
      console.log(auxCode);
      setReload(p => p + 1);
  
    }
  
    const updateAuxPhage = (value) => {
      auxPhage = value.target.value;
      updateAuxCode(auxPhage, auxGeneration)
    }
  
    const updateAuxGeneration = (value) => {
      auxGeneration = value.target.value;
      updateAuxCode(auxPhage, auxGeneration)
    }
  */

  return (
    <Create
      title="Create Phage"
      undoable={false}
      onSuccess={onSuccess}
      submitOnEnter={true}
      actions={<MyCreateActions />}
      classes={classes}
      {...props}
    >
      <SimpleForm>

        <TextInput label="Phage name" source="phage" validate={required()} /* onChange={value => updateAuxPhage(value)} */ />
        <NumberInput label="Generation" source="generation" /*validate={required()}*//* onChange={value => updateAuxGeneration(value)} */ />

        <TextInput source="code" validate={required()} />

        <ReferenceInput
          label="Sample"
          source="id_sample"
          reference="samples"
          //validate={required()}
        >
          <AutocompleteInput
            resettable={true}
            clearAlwaysVisible={true}
            optionText="code"
            //shouldRenderSuggestions={(value) => value.trim().length > 1}
            suggestionLimit={10}
          />
        </ReferenceInput>

        <TextInput label="Phage method" source="phage_method" />

        <ReferenceInput
          label="Bacteria of isolation"
          source="id_bacteria_of_isolation"
          reference="isolates"
        >
          <AutocompleteInput
            resettable={true}
            clearAlwaysVisible={true}
            optionText="code"
            shouldRenderSuggestions={(value) => value.trim().length > 1}
            suggestionLimit={10}
          />
        </ReferenceInput>

        <NumberInput label="Amount propagations" source="amount_propagations" />
        <TextInput label="Aproximate PFUs" source="aproximate_pfus" />

        <TextInput label="Notes" source="notes" multiline minRows={6} />

        {/* Storage */}
        <div className="">STORAGE</div>
        <TextInput source="phages_storages.tube_name" label="Tube name" />
        <NumberInput
          source="phages_storages.tube_size"
          label="Tube size (ml)"
          defaultValue={"4"}
        />
        <ReferenceInput
          perPage={999999} // FIXME: This is a hack to avoid the "perPage" error
          label="Storage"
          source="phages_storages.id_storage"
          reference="storages"
        >
          <SelectInput optionText="storage" />
        </ReferenceInput>
        <TextInput
          source="phages_storages.notes"
          label="Notes"
          multiline
          minRows={6}
        />
        {/* Host Range */}
        <div className="">HOST RANGE</div>
        {
          <GenericTable
            collectionName="phages_hosts"
            body={{
              id_isolate: undefined,
              is_external_isolate: false,
              concentration: undefined,
              quantification: undefined,
              kills: undefined,
              intensity: undefined,
              susceptibility: undefined,
              notes: undefined
            }}
            headers={["Isolates", "Concentration", "Quantificaction", "Kills?", "Intensity", "Susceptibility", "Notes"]}
            genericTableRow={PhagesHostsFields}
          >
          </GenericTable>
        }
        <br></br>
        {/* External Host Range */}
        <div className="">EXTERNAL HOST RANGE</div>
        {
          <GenericTable
            collectionName="phages_hosts"
            body={{
              id_external_isolate: undefined,
              is_external_isolate: true,
              concentration: undefined,
              quantification: undefined,
              kills: undefined,
              intensity: undefined,
              susceptibility: undefined,
              notes: undefined
            }}
            headers={["External Isolates", "Concentration", "Quantificaction", "Kills?", "Intensity", "Susceptibility", "Notes"]}
            genericTableRow={PhagesHostsExternalFields}
          >
          </GenericTable>
        }
      </SimpleForm>
    </Create>
  );
};
